import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "tabDialog"
};
const _hoisted_2 = {
  class: "fixed create_task_dialog_r"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存");
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  "element-loading-text": "数据加载中"
};
const _hoisted_6 = {
  class: "leftMenuDialog",
  style: {
    "position": "relative"
  }
};
const _hoisted_7 = /*#__PURE__*/_createTextVNode("添加文书");
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除文书");
const _hoisted_9 = /*#__PURE__*/_createTextVNode("重置文书");
const _hoisted_10 = ["onContextmenu"];
const _hoisted_11 = ["title"];
const _hoisted_12 = ["onContextmenu"];
const _hoisted_13 = ["title"];
const _hoisted_14 = {
  ref: "rightMenu"
};
const _hoisted_15 = {
  class: "fixed create_menu shadow",
  id: "addMenu",
  style: {
    "margin-top": "85px"
  }
};
const _hoisted_16 = {
  ref: "rightMenu"
};
const _hoisted_17 = {
  class: "fixed create_menu shadow",
  id: "delMenu",
  style: {
    "margin-top": "85px"
  }
};
const _hoisted_18 = {
  "element-loading-text": "正在保存中",
  style: {
    "width": "calc(100% - 260px)"
  }
};
const _hoisted_19 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_20 = /*#__PURE__*/_createTextVNode("重置");
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, null, -1);
const _hoisted_22 = {
  class: "aright pd0 mg0"
};
const _hoisted_23 = /*#__PURE__*/_createTextVNode("确定");
const _hoisted_24 = /*#__PURE__*/_createTextVNode("取消");
const _hoisted_25 = {
  class: "leftChildMenu",
  style: {
    "margin-top": "20px"
  }
};
const _hoisted_26 = ["title"];
const _hoisted_27 = {
  class: "liStyle"
};
const _hoisted_28 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_29 = /*#__PURE__*/_createTextVNode("重置");
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, null, -1);
const _hoisted_31 = {
  class: "liStyle"
};
const _hoisted_32 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_33 = /*#__PURE__*/_createTextVNode("重置");
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", null, null, -1);
const _hoisted_35 = {
  class: "liStyle"
};
const _hoisted_36 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_37 = /*#__PURE__*/_createTextVNode("重置");
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_FolderOpened = _resolveComponent("FolderOpened");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_Document = _resolveComponent("Document");
  const _component_el_tree = _resolveComponent("el-tree");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_DocEditor = _resolveComponent("DocEditor");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_dialog_sec = _resolveComponent("el-dialog-sec");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.activeName,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.activeName = $event),
    onTabClick: $options.tabClick
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "基本信息",
      name: "first"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.saveAllData,
        style: {
          "margin": "15px"
        }
      }, {
        default: _withCtx(() => [_hoisted_3]),
        _: 1
      }, 8, ["onClick"]), _createElementVNode("iframe", {
        name: "formFrame",
        id: "formFrame",
        ref: "formFrame",
        src: $props.obj.htmlAddress,
        class: "bgffffff width100P nborder",
        style: _normalizeStyle({
          height: $data.iframeHeight
        })
      }, null, 12, _hoisted_4)])]),
      _: 1
    }), $props.obj.secondVisible ? (_openBlock(), _createBlock(_component_el_tab_pane, {
      key: 0,
      label: "文书管理",
      name: "second"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_container, {
        class: "width100PH"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $options.createWS
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $options.delWS
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: $options.resetDocument
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }, 8, ["onClick"])]), _createVNode(_component_el_scrollbar, {
          class: "elscrModules"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tree, {
            data: $data.bookTreeList,
            "node-key": "id",
            props: $data.defaultProps,
            "default-expand-all": "",
            onNodeClick: $options.bookNodeClick,
            "highlighted-current": "",
            ref: "bookTree"
          }, {
            default: _withCtx(({
              node,
              data
            }) => [data.is_catalog ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              onContextmenu: _withModifiers($event => $options.rightKeyClick($event, data, '#addMenu'), ["prevent"])
            }, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_FolderOpened)]),
              _: 1
            }), _createElementVNode("span", {
              title: node.label
            }, _toDisplayString(node.label), 9, _hoisted_11)], 40, _hoisted_10)) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              onContextmenu: _withModifiers($event => $options.rightKeyClick($event, data, '#delMenu'), ["prevent"]),
              class: "menuActive"
            }, [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_Document)]),
              _: 1
            }), _createElementVNode("span", {
              title: node.label
            }, _toDisplayString(node.label), 9, _hoisted_13)], 40, _hoisted_12))]),
            _: 1
          }, 8, ["data", "props", "onNodeClick"])]),
          _: 1
        }), _withDirectives(_createElementVNode("div", _hoisted_14, [_createElementVNode("ul", _hoisted_15, [_createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = (...args) => $options.createWS && $options.createWS(...args))
        }, "添加文书")])], 512), [[_vShow, $data.addMenuVisible]]), _withDirectives(_createElementVNode("div", _hoisted_16, [_createElementVNode("ul", _hoisted_17, [_createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = (...args) => $options.delWS && $options.delWS(...args))
        }, "删除文书")])], 512), [[_vShow, $data.delMenuVisible]])])])), [[_directive_loading, $data.templateLoading]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_main, {
          class: "borderTable",
          style: {
            "width": "100%",
            "height": "calc(100vh - 100px)"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_DocEditor, {
            ref: "docEditor",
            resetVisible: $data.resetVisible,
            mbData: $data.mbData,
            baseInfo: $data.baseInfo,
            onSave: $options.saveTemplate
          }, null, 8, ["resetVisible", "mbData", "baseInfo", "onSave"])]),
          _: 1
        })])), [[_directive_loading, $data.wsLoading]])]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "onTabClick"])]), _createVNode(_component_el_dialog_sec, {
    ref: "dialogScjr",
    width: "900px",
    onOnsubmit: $options.onsubmitScjr,
    title: "受抽检人",
    "append-to-body": ""
  }, {
    form: _withCtx(() => [_createVNode(_component_el_form, {
      inline: true,
      ref: "headFormScjr"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "对象类别：",
        prop: "range"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.tableScjr.params.dxlb,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.tableScjr.params.dxlb = $event),
          placeholder: "请选择类别",
          class: "width100P"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "单位",
            value: "单位"
          }), _createVNode(_component_el_option, {
            label: "个人",
            value: "个人"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "单位/个人/设备使用者名称：",
        "label-width": "120px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.tableScjr.params.mc,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.tableScjr.params.mc = $event),
          placeholder: "请输入名称"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.searchScjr
        }, {
          default: _withCtx(() => [_hoisted_19]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $options.searchClearScjr
        }, {
          default: _withCtx(() => [_hoisted_20]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 512), _hoisted_21, _createVNode(_component_el_table, {
      ref: "scjr_table",
      data: $data.tableScjr.scjrData,
      "row-key": "id",
      border: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        fixed: "",
        type: "selection",
        width: "55"
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tableScjr.tablecol, (item, index) => {
        return _openBlock(), _createBlock(_component_el_table_column, {
          key: index,
          prop: item.prop,
          label: item.label,
          width: item.width
        }, null, 8, ["prop", "label", "width"]);
      }), 128))]),
      _: 1
    }, 8, ["data"]), _createVNode(_component_el_pagination, {
      background: "",
      class: "pagination",
      "current-page": $data.tableScjr.currpage,
      layout: "prev,pager,next,sizes,total,jumper",
      "page-sizes": [10, 15, 20, 30, 40, 50],
      "page-size": 10,
      total: $data.tableScjr.tableCount,
      onCurrentChange: $options.handleCurrentChange,
      onSizeChange: $options.handleSizeChange
    }, null, 8, ["current-page", "total", "onCurrentChange", "onSizeChange"])]),
    _: 1
  }, 8, ["onOnsubmit"]), _createVNode(_component_el_dialog_sec, {
    ref: "dialogCpxx",
    onOnsubmit: $options.onsubmitCpxx,
    title: '产品信息-' + $data.tableCpxx.currentNcplx,
    fullscreen: "",
    defaultBtn: false,
    style: {
      "overflow": "hidden"
    }
  }, {
    form: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.onsubmitCpxx
    }, {
      default: _withCtx(() => [_hoisted_23]),
      _: 1
    }, 8, ["onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.$refs.dialogCpxx.visible = false)
    }, {
      default: _withCtx(() => [_hoisted_24]),
      _: 1
    })]), _createVNode(_component_el_container, {
      class: "height100P"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_scrollbar, {
        class: "elscrModules"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tree, {
          data: $data.treeList,
          "node-key": "id",
          props: $data.defaultProps,
          "default-expand-all": "",
          onNodeClick: $options.handleNodeClick,
          ref: "tree"
        }, {
          default: _withCtx(({
            node,
            data
          }) => [_createElementVNode("span", {
            title: node.label
          }, _toDisplayString(node.label), 9, _hoisted_26)]),
          _: 1
        }, 8, ["data", "props", "onNodeClick"])]),
        _: 1
      })]), $data.tableCpxx.currentNcplx === '有机产品' ? (_openBlock(), _createBlock(_component_el_main, {
        key: 0,
        style: {
          "overflow": "hidden"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true,
          ref: "headFormCpxx"
        }, {
          default: _withCtx(() => [_createElementVNode("ul", _hoisted_27, [_createElementVNode("li", null, [_createVNode(_component_el_form_item, {
            label: "证书编号："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.tableCpxx.paramsYJ.ZSBH,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.tableCpxx.paramsYJ.ZSBH = $event),
              type: "text",
              placeholder: "请输入证书编号"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "企业名称："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.tableCpxx.paramsYJ.QYMC,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.tableCpxx.paramsYJ.QYMC = $event),
              type: "text",
              placeholder: "请输入企业名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.searchCpxx
            }, {
              default: _withCtx(() => [_hoisted_28]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.searchClearCpxx
            }, {
              default: _withCtx(() => [_hoisted_29]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })])])]),
          _: 1
        }, 512), _hoisted_30, _createVNode(_component_el_table, {
          ref: "cpxx_table",
          data: $data.tableCpxx.cpxxData,
          "row-key": "id",
          height: "500px",
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            fixed: "",
            type: "selection",
            width: "55"
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tableCpxx.tablecol, (item, index) => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              prop: item.prop,
              label: item.label,
              width: item.width
            }, null, 8, ["prop", "label", "width"]);
          }), 128))]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          background: "",
          class: "pagination",
          "current-page": $data.tableCpxx.currpage,
          layout: "prev,pager,next,sizes,total,jumper",
          "page-sizes": [10, 15, 20, 30, 40, 50],
          "page-size": 10,
          total: $data.tableCpxx.tableCount,
          onCurrentChange: $options.handleCurrentChange,
          onSizeChange: $options.handleSizeChange
        }, null, 8, ["current-page", "total", "onCurrentChange", "onSizeChange"])]),
        _: 1
      })) : _createCommentVNode("", true), $data.tableCpxx.currentNcplx === '绿色产品' ? (_openBlock(), _createBlock(_component_el_main, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true,
          ref: "headFormCpxx"
        }, {
          default: _withCtx(() => [_createElementVNode("ul", _hoisted_31, [_createElementVNode("li", null, [_createVNode(_component_el_form_item, {
            label: "标志编号："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.tableCpxx.paramsLS.BZBH,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.tableCpxx.paramsLS.BZBH = $event),
              type: "text",
              placeholder: "请输入标志编号"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "企业名称："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.tableCpxx.paramsLS.QYMC,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.tableCpxx.paramsLS.QYMC = $event),
              type: "text",
              placeholder: "请输入企业名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "产品名称："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.tableCpxx.paramsLS.CPMC,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.tableCpxx.paramsLS.CPMC = $event),
              type: "text",
              placeholder: "请输入产品名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.searchCpxx
            }, {
              default: _withCtx(() => [_hoisted_32]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.searchClearCpxx
            }, {
              default: _withCtx(() => [_hoisted_33]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })])])]),
          _: 1
        }, 512), _hoisted_34, _createVNode(_component_el_table, {
          ref: "cpxx_table",
          data: $data.tableCpxx.cpxxData,
          "row-key": "id",
          height: "500px",
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            fixed: "",
            type: "selection",
            width: "55"
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tableCpxx.tablecol, (item, index) => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              prop: item.prop,
              label: item.label,
              width: item.width
            }, null, 8, ["prop", "label", "width"]);
          }), 128))]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          background: "",
          class: "pagination",
          "current-page": $data.tableCpxx.currpage,
          layout: "prev,pager,next,sizes,total,jumper",
          "page-sizes": [10, 15, 20, 30, 40, 50],
          "page-size": 10,
          total: $data.tableCpxx.tableCount,
          onCurrentChange: $options.handleCurrentChange,
          onSizeChange: $options.handleSizeChange
        }, null, 8, ["current-page", "total", "onCurrentChange", "onSizeChange"])]),
        _: 1
      })) : _createCommentVNode("", true), $data.tableCpxx.currentNcplx === '无公害产品' ? (_openBlock(), _createBlock(_component_el_main, {
        key: 2
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true,
          ref: "headFormCpxx"
        }, {
          default: _withCtx(() => [_createElementVNode("ul", _hoisted_35, [_createElementVNode("li", null, [_createVNode(_component_el_form_item, {
            label: "证书编号："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.tableCpxx.paramsWGH.ZSBH,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.tableCpxx.paramsWGH.ZSBH = $event),
              type: "text",
              placeholder: "请输入证书编号"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "申请人全称："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.tableCpxx.paramsWGH.SQRQC,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.tableCpxx.paramsWGH.SQRQC = $event),
              type: "text",
              placeholder: "请输入申请人全称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "产品名称："
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: $data.tableCpxx.paramsWGH.CPMC,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.tableCpxx.paramsWGH.CPMC = $event),
              type: "text",
              placeholder: "请输入产品名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.searchCpxx
            }, {
              default: _withCtx(() => [_hoisted_36]),
              _: 1
            }, 8, ["onClick"]), _createVNode(_component_el_button, {
              type: "primary",
              onClick: $options.searchClearCpxx
            }, {
              default: _withCtx(() => [_hoisted_37]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })])])]),
          _: 1
        }, 512), _hoisted_38, _createVNode(_component_el_table, {
          ref: "cpxx_table",
          data: $data.tableCpxx.cpxxData,
          "row-key": "id",
          height: "500px",
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            fixed: "",
            type: "selection",
            width: "55"
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tableCpxx.tablecol, (item, index) => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              prop: item.prop,
              label: item.label,
              width: item.width
            }, null, 8, ["prop", "label", "width"]);
          }), 128))]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          background: "",
          class: "pagination",
          "current-page": $data.tableCpxx.currpage,
          layout: "prev,pager,next,sizes,total,jumper",
          "page-sizes": [10, 15, 20, 30, 40, 50],
          "page-size": 10,
          total: $data.tableCpxx.tableCount,
          onCurrentChange: $options.handleCurrentChange,
          onSizeChange: $options.handleSizeChange
        }, null, 8, ["current-page", "total", "onCurrentChange", "onSizeChange"])]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }, 8, ["onOnsubmit", "title"]), _createVNode(_component_el_dialog_sec, {
    ref: "dialogTem",
    width: "800px",
    onOnsubmit: $options.onsubmitTem,
    title: "添加文书",
    "append-to-body": ""
  }, {
    form: _withCtx(() => [_createVNode(_component_el_table, {
      ref: "temTable",
      data: $data.temTable.templateData,
      "row-key": "id",
      border: "",
      class: "selectCSS"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        fixed: "",
        type: "selection",
        width: "55"
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.temTable.tablecol, (item, index) => {
        return _openBlock(), _createBlock(_component_el_table_column, {
          key: index,
          prop: item.prop,
          label: item.label,
          width: item.width
        }, null, 8, ["prop", "label", "width"]);
      }), 128))]),
      _: 1
    }, 8, ["data"])]),
    _: 1
  }, 8, ["onOnsubmit"])], 64);
}